import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'pgh-coverage-home',
  templateUrl: './coverage-home.component.html',
  styleUrls: ['./coverage-home.component.scss'],
})
export class CoverageHomeComponent implements OnInit, OnDestroy {

  private onDestroy$ = new Subject<void>();

  constructor(
    public route: ActivatedRoute,
    public httpClient: HttpClient
  ) {}

 ngOnInit() {
    window.scrollTo(0, 0);
   }

  ngOnDestroy() {
    document.documentElement.className = '';
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
